import Actions from '@/Components/Storemanager/InitialColumn/Actions';
import Category from '@/Components/Storemanager/InitialColumn/Category';
import Field from '@/Components/Storemanager/InitialColumn/Field';
import Title from '@/Components/Storemanager/InitialColumn/Title';
import FieldCategory from '@/Models/FieldCategory';

export default {
    functional: true,

    props: {
        rows: {
            type: Array,
            required: true,
        },
        hasActions: {
            type: Boolean,
            required: true,
        },
    },

    scopedSlots: {
        title: null,
        actions: null,
    },

    render(createElement, context) {
        let elements = [];

        // Table Title
        const title = createElement(Title, {
            props: {
                hasCategories: !!context.props.rows.find(row => row instanceof FieldCategory),
            },
            scopedSlots: {
                title: context.scopedSlots.title,
                actions: context.scopedSlots.actions,
            },
            on: context.listeners,
            class: ['border-b', context.data.class],
        }, []);

        elements.push(title);

        // Actions
        if (context.props.hasActions) {
            elements.push(
                createElement(Actions, {class: [{'border-b': context.props.rows.length > 0}, context.data.class]}));
        }

        // Field/Category Rows
        context.props.rows.forEach((row, index) => {
            const lastRow = index === context.props.rows.length - 1;

            if (row instanceof FieldCategory) {
                // Category Row
                elements.push(
                    createElement(Category, {
                        props: {
                            category: row,
                        },
                        class: [{'border-b': !lastRow}, context.data.class],
                    }),
                );

                row.filteredFields.forEach((field, i) => {
                    const lastField = i === row.filteredFields.length - 1;

                    elements.push(
                        createElement(Field, {
                            props: {
                                label: field.label,
                            },
                            class: [
                                {'border-b': !(lastField && lastRow), 'hidden': !row.isOpen},
                                context.data.class,
                            ],
                        }),
                    );
                });
            } else if (!row.is_admin_only || auth.user.isAdmin) {
                // Field Row
                elements.push(
                    createElement(Field, {
                        props: {
                            label: row.label,
                        },
                        class: [{'border-b': !lastRow}, context.data.class],
                    }),
                );
            }
        });

        return elements;
    },
};
